/* eslint-disable */
export default {
  close: 'Chiudi',
} as const;

// @key: @#@"close"@#@ @source: @#@"Close"@#@
